import { AuthService } from "@/services";
import { mapActions } from "vuex";
import * as types from "./../../../store/types";

export default {
  name: "register-verification",
  components: {},
  props: [],
  data() {
    return {
      otpCode: "",
      loading: false,
      countdownTimer: "00:00",
      remainingMilliseconds: 0,
      clockInterval: null,
      repeatLoading: false,
      otpRules: [
        v =>
          !!v ||
          this.$t(
            "authPage.registerVerificationPage.verificationCode.validation"
          )
      ],
      valid: false
    };
  },
  computed: {
    formattedCountdownTimer() {
      const totalSeconds = Math.floor(this.remainingMilliseconds / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

      return `${formattedMinutes}:${formattedSeconds}`;
    },
    otpToken() {
      return localStorage.getItem("otpToken");
    },
    emailOrMobile() {
      return localStorage.getItem("emailOrMobile");
    },
    ttl() {
      return localStorage.getItem("ttl");
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.clearCountdown();
  },
  methods: {
    ...mapActions({
      checkIsAuth: types.auth.actions.ACTION_CHECK_IS_AUTH
    }),
    init() {
      const storedEndTime = localStorage.getItem("ttl");
      if (storedEndTime) {
        const endTime = parseInt(storedEndTime, 10);
        const now = Date.now();
        const timeLeft = endTime - now;

        if (timeLeft > 0) {
          this.remainingMilliseconds = timeLeft;
          this.startCountdown(endTime);
        } else {
          this.clearCountdown();
          this.remainingMilliseconds = 0;
        }
      } else {
        this.remainingMilliseconds = 0;
      }
    },
    onSubmit() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.verifyRegistration();
      } else {
        this.loading = false;
      }
    },
    verifyRegistration() {
      let otpToken = localStorage.getItem("otpToken");
      let GACID = this.$cookies.get("_ga");
      let countryCode = localStorage.getItem("countryCode") || null;
      AuthService.verifyRegister(this.otpCode, otpToken, GACID, countryCode)
        .then(() => {
          // localStorage.setItem("accessToken", response.data.data.token);
          // localStorage.setItem("isAuth", true);
          // this.checkIsAuth();
          this.$router.push("/auth/register/go-for-signin");
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resendOtpCode() {
      this.repeatLoading = true;
      let otpToken = localStorage.getItem("otpToken");
      AuthService.resendRegisterOtp(otpToken)
        .then(response => {
          localStorage.setItem("otpToken", response.data.data.otp_token);
          const ttl = response.data.data.ttl;
          const endTime = Date.now() + ttl;

          localStorage.setItem("ttl", endTime);
          this.startCountdown(endTime);

          this.$toast.success(response.data.message);
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
          this.clearCountdown();
          this.remainingMilliseconds = 0;
        })
        .finally(() => {
          this.repeatLoading = false;
        });
    },
    startCountdown(endTime) {
      if (this.clockInterval) {
        clearInterval(this.clockInterval);
      }
      this.clockInterval = setInterval(() => {
        const now = Date.now();
        let timeLeft = endTime - now;

        if (timeLeft <= 0) {
          this.remainingMilliseconds = 0;
          clearInterval(this.clockInterval);
          localStorage.removeItem("ttl");
          this.clockInterval = null;
        } else {
          this.remainingMilliseconds = timeLeft;
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.clockInterval) {
        clearInterval(this.clockInterval);
        this.clockInterval = null;
      }
      localStorage.removeItem("ttl");
    }
  }
};
